import { createApi } from '@reduxjs/toolkit/query/react';
import { prepareHeaders } from '../configuration/tokenHandling/prepareHeaders';
import baseQueryWithErrorHandling from './baseQuery';

export type Asset = {
    items: Items[];
    _links?: {
        self: {
            href: string;
        };
    };
};

export type Items = {
    id: string;
    account_id: string;
    name: string;
    status: string;
    type: string;
    identification: string;
    identification_type: string;
    brand: string;
    license_plate: string | null;
    license_plate_country_code: string;
};

export const assetsApi = createApi({
    reducerPath: 'assetsApi',
    baseQuery: baseQueryWithErrorHandling({ baseUrl: 'https://api.assets.rio.cloud/assets' }),
    endpoints: builder => ({
        fetchAssets: builder.query<Items[], string | undefined>({
            query: () => ({
                url: '?status=active',
                responseHandler: async (response: Response) => {
                    const data = await response.json();
                    if (data?.items) {
                        return data.items?.filter(
                            (item: Items) => (item.type === 'bus' || item.type === 'truck') && item.identification
                        );
                    }
                    return [];
                },
            }),
            keepUnusedDataFor: 10,
        }),

        fetchAssetByIdentification: builder.query<string[], string>({
            query: identification => ({
                url: `?status=active&identification=${identification}`,
                responseHandler: async (response: Response) => {
                    const data: Asset = await response.json();
                    if (data?.items && data.items.length > 0) {
                        // Return only the IDs of the items
                        return data.items.map(item => item.id);
                    }
                    return [];
                },
            }),
            keepUnusedDataFor: 10,
        }),
    }),
});

export const { useFetchAssetsQuery, useFetchAssetByIdentificationQuery, useLazyFetchAssetByIdentificationQuery } =
    assetsApi;
